export type GuestPromptLogout = () => void | Promise<void>;

type OpenPayload = { logout: GuestPromptLogout };

type Listener = (payload: OpenPayload | null) => void;

let listener: Listener | null = null;
/** Host mount olmadan önce gelen istekler (ilk frame / hızlı dokunuş) */
let pendingOpen: GuestPromptLogout | null = null;

export function registerGuestPromptListener(l: Listener) {
  listener = l;
  if (pendingOpen) {
    const fn = pendingOpen;
    pendingOpen = null;
    l({ logout: fn });
  }
  return () => {
    if (listener === l) {
      listener = null;
    }
  };
}

export function emitOpenGuestPrompt(logout: GuestPromptLogout) {
  if (listener) {
    listener({ logout });
    return;
  }
  pendingOpen = logout;
}
